<template>
  <div class="thisbox" style="display: flex">
    <i-button type="primary" style="margin-bottom: 24px; margin-right: 10px; height: 2rem" @click="addshebei"
      >添加编码</i-button
    >
    <div v-if="show">
      <div
        v-for="(item, index) in sensorList.sensorlist"
        :key="item.id"
        class="view-box view-box-thisbox"
        :class="index + 1 < sensorList.sensorlist.length ? 'view_box_border' : ''"
      >
        <div class="view-box-top" style="height: 5rem; width: auto">
          <Dropdown class="tabdiv" @on-click="thisSelect($event, index)">
            <a href="javascript:void(0)">
              编码字典
              <Icon type="ios-arrow-down" />
            </a>
            <div slot="list">
              <div style="margin: 5px 10px; width: 100%">
                <Input v-model="item.inputValue" placeholder="请输入编码" style="width: 120px" />
              </div>
              <div>
                <DropdownMenu class="dropstyle">
                  <template v-for="(item2, index2) in xlList">
                    <DropdownItem
                      :key="index2"
                      v-if="!item.inputValue || item2.code_name.indexOf(item.inputValue) != -1"
                      :name="item2.code_name"
                      >{{ item2.code_name }} ({{ item2.cn_name }})</DropdownItem
                    >
                  </template>
                </DropdownMenu>
              </div>
            </div>
          </Dropdown>
          <Dropdown v-if="yytypes == 0" class="tabdiv" @on-click="thisSelects($event, index)">
            <a href="javascript:void(0)">
              字典编号
              <Icon type="ios-arrow-down" />
            </a>
            <DropdownMenu slot="list" class="dropstyle">
              <DropdownItem name="01">01</DropdownItem>
              <DropdownItem name="02">02</DropdownItem>
              <DropdownItem name="03">03</DropdownItem>
              <DropdownItem name="04">04</DropdownItem>
              <DropdownItem name="05">05</DropdownItem>
              <DropdownItem name="06">06</DropdownItem>
              <DropdownItem name="07">07</DropdownItem>
              <DropdownItem name="08">08</DropdownItem>
              <DropdownItem name="09">09</DropdownItem>
              <DropdownItem name="10">10</DropdownItem>
              <DropdownItem name="11">11</DropdownItem>
              <DropdownItem name="12">12</DropdownItem>
              <DropdownItem name="13">13</DropdownItem>
              <DropdownItem name="14">14</DropdownItem>
              <DropdownItem name="15">15</DropdownItem>
              <DropdownItem name="16">16</DropdownItem>
              <DropdownItem name="17">17</DropdownItem>
              <DropdownItem name="18">18</DropdownItem>
              <DropdownItem name="19">19</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <div v-if="yytypes == 0" class="xuanze">
            {{
              item.code + '' + (item.codenum == 0 ? '' : item.codenum.length == 2 ? item.codenum : '0' + item.codenum)
            }}
            <div>{{ item.code_name }}</div>
          </div>
          <div v-if="yytypes == 1" class="xuanze">
            <div>{{ item.code }}</div>
            <div>{{ item.code_name }}</div>
          </div>
          <div v-if="yytypes == 2" class="xuanze">
            <div>{{ item.code }}</div>
            <div>{{ item.code_name }}</div>
          </div>
          <div v-if="yytypes == 3" class="xuanze">
            <div>{{ item.code }}</div>
            <div>{{ item.code_name }}</div>
          </div>
          <Input v-model="item.highValue" size="large" style="width: 130px" placeholder="最高报警值" />
          <Input v-model="item.lowValue" size="large" style="width: 130px" placeholder="最低报警值" />
          <Icon type="ios-add-circle-outline" class="icon-b" />
          <Icon type="ios-add-circle-outline" class="icon-c" />
          <Icon type="ios-close-circle-outline" class="remove" @click="deldata(item.gkSensor_id, index)" />
          <Button type="primary" style="height: 2.25rem" @click="getTJInfo">确定</Button>
        </div>
      </div>
    </div>
    <Modal v-model="modal1" title="删除" @on-ok="ok" @on-cancel="cancel">
      <p>你确定要删除这一条数据吗？</p>
    </Modal>
  </div>
</template>

<script>
const that = this;
export default {
  props: ['sensorList'],

  data() {
    return {
      yytypes: '',
      value1: '',
      value2: '',
      value3: '',
      switch1: false,
      xlList: [],
      name: '',
      modal1: false,
      show: false,
      listindex: '',
      id: '',
    };
  },
  created() {
    this.yytypes = sessionStorage.getItem('yytype');
  },
  mounted() {
    this.getGKInfo();

    for (var i = 0; i < this.sensorList.length; i++) {
      if (!this.sensorList[i].selectname) {
        this.sensorList[i].selectname = '编码选择';
        this.sensorList[i].inputValue = '';
      }
    }
    this.show = true;
  },
  methods: {
    change(status) {
      this.$Message.info('开关状态：' + status);
    },
    deldata(id, index) {
      this.modal1 = true;
      this.id = id;
      this.listindex = index;
    },
    /**
     * 添加
     */
    adddiv: function () {
      this.sensorList.push({
        id: '',
        code: '',
        codenum: '',
        higValue: '',
        lowValue: '',
      });
    },
    ok() {
      const api = this.ApiUrl + 'gkSensor/delById';
      const data = {
        gkSensor_id: this.id,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success('删除成功');
            this.sensorList.sensorlist.splice(this.listindex, 1);
          } else {
            this.$Message.error('删除失败');
          }
        },
        res => {},
      );
    },
    cancel() {
      this.modal1 = false;
    },
    addshebei() {
      var that = this;
      if (this.sensorList.sensorlist.length != 0) {
        if (
          this.sensorList.sensorlist[this.sensorList.sensorlist.length - 1].code == '' ||
          this.sensorList.sensorlist[this.sensorList.sensorlist.length - 1].code == '默认值'
        ) {
          this.$Message.error('请填写完成设备信息在次添加新的设备');
          return;
        }
        if (this.yytypes == '0') {
          if (
            that.sensorList.sensorlist[that.sensorList.sensorlist.length - 1].codenum == '' ||
            that.sensorList.sensorlist[that.sensorList.sensorlist.length - 1].codenum == '默认值'
          ) {
            that.$Message.error('请填写完成设备信息在次添加新的设备');
            return;
          }
        }

        if (
          this.sensorList.sensorlist[this.sensorList.sensorlist.length - 1].highValue == '' ||
          this.sensorList.sensorlist[this.sensorList.sensorlist.length - 1].highValue == '默认值'
        ) {
          this.$Message.error('请填写完成设备信息在次添加新的设备');
          return;
        }
        if (
          this.sensorList.sensorlist[this.sensorList.sensorlist.length - 1].lowValue == '' ||
          this.sensorList.sensorlist[this.sensorList.sensorlist.length - 1].lowValue == '默认值'
        ) {
          this.$Message.error('请填写完成设备信息在次添加新的设备');
          return;
        }
      }
      const id = this.sensorList.gkSite_id;

      const api = this.ApiUrl + 'gkSensor/addGkSensor';
      const data = {
        gkSite_id: id,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          var that = this;

          if (res.data.extend.news == 0) {
            this.$Message.success('添加成功');
            const shebei = {};
            if (!shebei.code) {
              shebei.code = '';
            }
            if (that.yytypes == '0') {
              if (!shebei.codenum) {
                shebei.codenum = '';
              }
            }

            if (!shebei.gkSensor_id) {
              shebei.gkSensor_id = res.data.extend.gkSensor_id;
            }
            if (!shebei.highValue) {
              shebei.highValue = '';
            }
            if (!shebei.lowValue) {
              shebei.lowValue = '';
            }
            this.sensorList.sensorlist.push(shebei);
          } else {
            this.$Message.error('添加失败');
          }
        },
        res => {},
      );
    },
    thisSelect: function (e, index) {
      console.log(e);
      this.sensorList.sensorlist[index].code = e;
      console.log(this.sensorList.sensorlist[index].code);
    },
    thisSelects: function (e, index) {
      console.log(e);
      this.sensorList.sensorlist[index].codenum = e;
    },
    getGKInfo() {
      const api = this.ApiUrl + 'code/findAllGK';
      const data = {
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.xlList = res.data.extend.pageInfo;
            for (var i = 0; i < this.xlList.length; i++) {
              if (!this.xlList[i].name) {
                this.xlList[i].name = '选择编码';
              }
            }
          }
        },
        res => {},
      );
    },
    async getTJInfo() {
      const that = this;

      let checkFlag = await this.checkArrayNum();
      if (checkFlag) {
        this.$Message.warning('有重复测点，测点编号是' + checkFlag);
        return;
      }

      for (var i = 0; i < that.sensorList.sensorlist.length; i++) {
        const list = that.sensorList.sensorlist;
        if (list[i].code == '' || list[i].code == null) {
          this.$Message.error('请选择编码字典');
          return;
        }
        if (this.yytypes == 0) {
          if (list[i].codenum == '' || list[i].codenum == null) {
            this.$Message.error('请选择字典编号');
            return;
          }
        }
        if (list[i].highValue == '' || list[i].highValue == null) {
          this.$Message.error('请选择输入最高值');
          return;
        }
        if (list[i].lowValue == '' || list[i].lowValue == null) {
          this.$Message.error('请选择输入最低值');
          return;
        }

        if (that.sensorList.sensorlist[i].codenum > 0 && that.sensorList.sensorlist[i].codenum < 10) {
          that.sensorList.sensorlist[i].codenum = '0' + Number(that.sensorList.sensorlist[i].codenum);
        }
      }
      const api = this.ApiUrl + 'gkSensor/updateGkSensor';
      const data = {
        data: that.sensorList.sensorlist,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success('修改成功');
          } else {
            this.$Message.error('修改失败');
          }
        },
        res => {},
      );
    },
    // 对比数组中是否有重复的code
    checkArrayNum() {
      return new Promise((resolve, reject) => {
        let arr = [];
        let code = '';
        for (let i = 0; i < this.sensorList.sensorlist.length; i++) {
          let ele = this.sensorList.sensorlist[i];
          arr.push(ele.code);
        }
        arr = arr.sort();
        for (let i = 0; i < arr.length - 1; i++) {
          let ele = arr[i];

          if (ele == arr[i + 1]) {
            code = ele;
            break;
          }
        }
        resolve(code);
      });
    },
  },
};
</script>

<style scoped>
.view-box .icon {
  display: none;
}
.dropstyle {
  max-height: 200px;
  overflow: auto;
}

.thisbox {
  width: 100%;
  height: 100%;
  margin: 0.625rem 0;

  align-items: flex-end;
}

.icon-c {
  font-size: 1.875rem;
  color: #ffffff;
}

.icon-b {
  font-size: 1.875rem;
  color: #ffffff;
}

.thisbox .view-box:last-child .icon-b {
  display: none;
}

.thisbox .view-box:last-child .icon {
  display: block;
}

.thisbox .view-box button {
  display: none;
}

.thisbox .view-box:last-child button {
  display: block;
  margin-left: 1.25rem;
}

.tabdiv {
  width: auto;
  margin-right: 1.25rem;
}

.ivu-input-wrapper {
  width: 12.5rem;
  margin-right: 1.25rem;
}

.view-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 2s;
}

.view_box_border {
  border-bottom: 1px dashed #cccccc;
}

.remove {
  display: none;
  font-size: 1.875rem;
  color: #2db7f5;
  transition: all 2s;
}

.view-box-thisbox:hover .remove {
  display: block;
}

.view-box-thisbox:hover .icon-c {
  display: none;
}

.view-box-myxuanxiang {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ivu-input {
  width: 12.5rem;
}

.xuanze {
  width: #666;
  font-size: 14px;
  text-align: center;

  margin-right: 1.25rem;
}

.xuanze > div {
  line-height: 1em;
}

.xuanze > div:first-child {
  margin-bottom: 3px;
}

.view-box-top {
  width: 100%;
  display: flex;
  height: 3.125rem;
  align-items: center;
  /* justify-content: center; */
}
</style>
